import { render, staticRenderFns } from "./CommentsBlock.vue?vue&type=template&id=460ebf7e&scoped=true&"
import script from "./CommentsBlock.vue?vue&type=script&lang=js&"
export * from "./CommentsBlock.vue?vue&type=script&lang=js&"
import style0 from "./CommentsBlock.vue?vue&type=style&index=0&id=460ebf7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460ebf7e",
  null
  
)

export default component.exports